// utils/confirm.js
import { MessageBox } from 'element-ui'

const originalConfirm = MessageBox.confirm

const customConfirm = (message, title, options) => {
  let config = {}
  
  if (typeof title === 'object') {
    config = { ...title }
  } else if (typeof title === 'string') {
    config = options ? { ...options } : {}
    config.title = title
  } else {
    config = options ? { ...options } : {}
  }
  
  // 只针对 warning 类型设置自定义 class
  if (config.type === 'warning') {
    config.customClass = (config.customClass || '') + ' custom-warning-confirm'
    // 删除 type，避免 Element UI 默认样式干扰
    delete config.type
  }
  
  return originalConfirm(message, config.title, config)
}

export default customConfirm


// WEBPACK FOOTER //
// ./src/utils/confirm.js